export const DOCS_BASE_URL = 'https://docs.mbcom.cloud'
export const DOCS_HOME_URL = DOCS_BASE_URL
export const INTERNAL_DOCS_URL = 'https://intern.docs.mbcom.cloud'

export type DocKey =
  | 'changelog'
  | 'general-config.microtech-connection'
  | 'system-config.elo.configuration'
  | 'system-config.invoice.mail-configuration'
  | 'system-config.invoice.microtech-configuration'
  | 'system-config.workflow.microtech-configuration'
  | 'tenant-config.microtech-portal-config'
  | 'tenant-config.invoice-portal-config'
  | 'tenant-config.mail-portal-config'
  | 'tenant-config.elo-portal-config'
  | 'tenant-config.workflow-portal-config'

const DOC_PATHS: Record<DocKey, string> = {
  changelog: '/changelog',
  'general-config.microtech-connection': '/base/microtech-connection',
  'system-config.elo.configuration': '/products/elo/system-config/configuration',
  'system-config.invoice.mail-configuration': '/products/invoice/system-config/mail-configuration',
  'system-config.invoice.microtech-configuration': '/products/invoice/system-config/microtech-configuration',
  'system-config.workflow.microtech-configuration': '/products/workflow/system-config/microtech-configuration',
  'tenant-config.microtech-portal-config': '/base/microtech-portal-config',
  'tenant-config.invoice-portal-config': '/products/invoice/tenant-config/invoice-portal-config',
  'tenant-config.mail-portal-config': '/products/invoice/tenant-config/mail-portal-config',
  'tenant-config.elo-portal-config': '/products/elo/tenant-config/elo-portal-config',
  'tenant-config.workflow-portal-config': '/products/workflow/tenant-config/workflow-portal-config',
}

export const getDocsUrl = (key: DocKey): string => `${DOCS_BASE_URL}${DOC_PATHS[key]}`
